import i18n from '../../translations/i18n'

/**
 * App language -> Google Maps JS API `language` code.
 * Google still documents Hebrew as the legacy "iw" code.
 */
const MAPS_LANGUAGE_BY_APP_LANGUAGE: Record<string, string> = {
  en: 'en',
  he: 'iw',
  es: 'es',
  ar: 'ar',
  th: 'th',
}

let frozenMapsLanguage: string | null = null

/**
 * Returns the language the Google Maps JS API should load with (map controls
 * such as "Map / Satellite", place labels, Places autocomplete results).
 *
 * The Maps JS API can only be loaded once per page, with one language. Both
 * loaders used in this app (@vis.gl/react-google-maps APIProvider and
 * @react-google-maps/api useJsApiLoader) must therefore receive the same value
 * on every mount — @react-google-maps/api even throws "Loader must not be called
 * again with different options" otherwise. So the value is captured from the
 * current i18n language the first time a map is rendered and then kept for the
 * lifetime of the page. After switching the app language, the map UI follows
 * the new language on the next page reload.
 */
export function getMapsLanguage(): string {
  if (!frozenMapsLanguage) {
    const appLanguage = (i18n.language || 'en').split('-')[0]
    frozenMapsLanguage = MAPS_LANGUAGE_BY_APP_LANGUAGE[appLanguage] || 'en'
  }
  return frozenMapsLanguage
}
